var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    { staticClass: "mb-3", attrs: { "has-toggle": false } },
    [
      _c("div", { staticClass: "row py-3 mr-md-0 n-ml" }, [
        _c("div", { staticClass: "col-md-2 col-12 text-center border-right" }, [
          _c(
            "div",
            {
              staticClass: "badge badge-pill font-16 py-2 my-2 w-100",
              style: {
                "background-color": _vm.areaColor.bgColor,
                color: _vm.areaColor.color
              }
            },
            [_vm._v(" " + _vm._s(_vm.data.area?.name) + " ")]
          ),
          _c("span", { staticClass: "color-gray-6 d-block font-14 pt-1" }, [
            _vm._v(" No. de Rúbrica: ")
          ]),
          _c("span", { staticClass: "font-weight-bold" }, [
            _vm._v(" " + _vm._s(_vm.data.number) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md col-12 pl-4 pr-0" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md-3" }, [
              _c("div", { staticClass: "mb-2" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Servicio a Ofrecer: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.data.service?.name)) + " "
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c("div", { staticClass: "mb-2" }, [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Tipo de Evaluación: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.data.type?.name)) + " "
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-md" }, [
              _c("div", [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Estatus: ")
                ]),
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _c("em", {
                    staticClass: "fas fa-circle mr-2 font-12",
                    style: { color: _vm.statusColor }
                  }),
                  _c(
                    "span",
                    { staticClass: "font-16 color-black font-weight-bold" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("empty")(_vm.data.status?.name)) +
                          " "
                      )
                    ]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md" }, [
              _c("div", [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Año Académico: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("empty")(_vm.data.academicYear?.name)) +
                      " "
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md" }, [
              _c("div", [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Fecha de Creación: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(" " + _vm._s(_vm._f("date")(_vm.data.date)) + " ")
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md" }, [
              _c("div", [
                _c("span", { staticClass: "color-gray-6 d-block font-14" }, [
                  _vm._v(" Fecha de Publicación: ")
                ]),
                _c("span", { staticClass: "font-16 color-black" }, [
                  _vm._v(
                    " " + _vm._s(_vm._f("date")(_vm.data.publicationDate)) + " "
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm.actionItems.length
          ? _c(
              "div",
              {
                staticClass:
                  "col-md-1 col-12 pr-5 d-flex align-items-center justify-content-center"
              },
              [
                _c("dropdown", {
                  staticClass: "actions-dropdown",
                  attrs: {
                    "always-show-dropdown": "",
                    items: _vm.actionItems,
                    title: "Acciones"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }